<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>Exhibiting</BreadcrumbItem>
          <BreadcrumbItem>Show Catalogue</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibitionEn/index/exinfo/catalogue-alter');">
          <span>Back</span>
        </div>
      </div>
    </div>

    <div class="catalogue-content">
      <div style="display:flex;">
        <div class="catalogue-content-l">
          <div class="catalogue-content-r">
            <Form label-position="right" :label-width="220" @submit.native.prevent>
              <FormItem label="Logo：" prop="logo">
                <div class="logo-example">
                  <template v-if="uploadList && uploadList.length">
                    <div
                      class="my-upload-list"
                      v-for="(item, index) in uploadList"
                      :key="'upload' + index"
                      style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;"
                    >
                      <template v-if="item.status === 'finished'">
                        <img :src="item.url" style="width: 150px;height: 150px;" v-if="item.url" />
                        <img :src="Logo" style="width: 150px;height: 150px;" v-else />
                        <div class="my-upload-list-cover">
                          <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        </div>
                      </template>
                      <template v-else>
                        <Spin v-if="item.showProgress" style="width: 150px;height: 150px;">
                          <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                        </Spin>
                      </template>
                    </div>
                  </template>

                  <div
                    class="my-upload-list"
                    style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;"
                    v-else
                  >
                    <img src="@assets/img/empty.png" style="width: 150px;height: 150px;" />
                  </div>
                  <div class="logo-example-box">
                    <div class="logo-example-item z-large-s">
                      <img
                        v-if="uploadList && uploadList[0]"
                        :src="uploadList[0].url"
                        style="width: 40px;height: 40px;"
                      />
                      <!-- <div v-else style="width:40px;height:40px;border:1px solid #bfbfbf;"></div> -->
                      <img v-else src="@assets/img/empty.png" />
                      <p>size：200*200px</p>
                    </div>
                    <div class="logo-example-item z-large-m">
                      <img
                        :src="uploadList[0].url"
                        v-if="uploadList && uploadList[0]"
                        style="width: 30px;height: 30px;"
                      />
                      <!-- <div v-else style="width:30px;height:30px;border:1px solid #bfbfbf;"></div> -->
                      <img v-else src="@assets/img/empty.png" />
                      <p>size：120*120px</p>
                    </div>
                    <div class="logo-example-item z-large-l">
                      <img
                        :src="uploadList[0].url"
                        v-if="uploadList && uploadList[0]"
                        style="width: 20px;height: 20px;"
                      />
                      <!-- <div v-else style="width:20px;height:20px;border:1px solid #bfbfbf;"></div> -->
                      <img v-else src="@assets/img/empty.png" />
                      <p>size：30*30px</p>
                    </div>
                  </div>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  :action="uploadUrl"
                  style="display: inline-block;position: relative;"
                >
                  <Button icon="ios-cloud-upload-outline">Change</Button>
                  <!-- 蒙版 -->
                  <div
                    class="mask"
                    style="position:absolute;opacity:0;width:115px;height:34px;left:0;top:0;"
                    @click.stop="selectType"
                  ></div>
                </Upload>
                <p class="upload-p">(.jpg/.png within 2M, suggested size is 120*120px)</p>
              </FormItem>
            </Form>
          </div>
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="220"
            @submit.native.prevent
          >
            <FormItem label="Company name：">
              <Input type="text" v-model="formInline.name" disabled />
            </FormItem>
            <FormItem label="Booth number：">
              <Input type="text" v-model="formInline.exHall" disabled />
            </FormItem>
            <FormItem label="Country/Region：" required style="margin-bottom: 0;">
              <Row type="flex" justify="space-between">
                <Col span="7">
                  <FormItem prop="country">
                    <Select 
                      v-model="formInline.country"
                      placeholder="Country/Region"
                      @on-change="changeCountry"
                      filterable
                    >
                      <Option
                        v-for="(item, index) in countryList"
                        :key="item.name"
                        :value="item.name"
                        @click.native="changeCountryValue(item)"
                      >{{ item.nameEn }}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="7" v-if="formInline.country === '中国'">
                  <FormItem prop="province">
                    <Select
                      v-model="formInline.province"
                      placeholder="请选择省份"
                      @on-change="changeProvince"
                    >
                      <Option
                        v-for="(item, index) in provinceArr"
                        :key="'province-' + index"
                        :value="item.shortname?item.shortname:item.name"
                        @click.native="changeProvinceValue(item)"
                      >{{ item.pinyin }}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="7" v-if="formInline.country === '中国' && citiesArr && citiesArr.length">
                  <FormItem prop="city">
                    <Select v-model="formInline.city" placeholder="请选择城市">
                      <Option
                        v-for="(item, index) in citiesArr"
                        :key="'city-' + index"
                        :value="item.shortname?item.shortname:item.name"
                        @click.native="changeCity(item)"
                      >{{ item.pinyin }}</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
            </FormItem>
            <FormItem label="Address：" required style="margin-bottom: 0;">
              <Row type="flex" justify="space-between">
                <Col span="16">
                  <FormItem prop="address">
                    <Input type="text" v-model="formInline.address" placeholder="Please enter the street number" />
                  </FormItem>
                </Col>
                <Col span="7">
                  <FormItem prop="mail">
                    <Input type="text" v-model="formInline.mail" placeholder="Please enter the postal code" />
                  </FormItem>
                </Col>
              </Row>
            </FormItem>
            <!-- <FormItem label="企业类型：" prop="type">
              <Select v-model="formInline.type" placeholder="请选择企业类型">
                <Option
                  v-for="(item, index) in exTypeList"
                  :key="item.name"
                  :value="item.name"
                >{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="人员规模：" prop="staff">
              <Select
                v-model="formInline.staff"
                placeholder="请选择企业类型"
              >
                <Option
                  v-for="(item, index) in staffArr"
                  :key="item.value"
                  :value="item.value"
                >{{ item.value }}</Option>
              </Select>
            </FormItem>
            <FormItem label="年销售额：" prop="sales">
              <Input type="text" v-model="formInline.sales" placeholder="请输入年销售额" />
            </FormItem> -->
            <FormItem label="Company website：">
              <Input type="text" v-model="formInline.url" placeholder="Company website" />
            </FormItem>
            <FormItem label="Company email：" prop="email">
              <Input type="text" v-model="formInline.email" placeholder="Company email" />
            </FormItem>
            <FormItem label="Contact：" required style="margin-bottom: 0;">
              <Row>
                <Col span="3" style="padding: 0;">
                  <FormItem prop="LinkFirstName">
                    <Input type="text" v-model="formInline.LinkFirstName" placeholder="Surname" />
                  </FormItem>
                </Col>
                <Col span="5" style="margin-left: 8px;">
                  <FormItem prop="LinkLastName">
                    <Input type="text" v-model="formInline.LinkLastName" placeholder="first name" />
                  </FormItem>
                </Col>
              </Row>
            </FormItem>
            <FormItem label="Contact mobile：" prop="LinkMob">
              <Input
                style="width:calc(100% - 145px)"
                type="text"
                v-model="formInline.LinkMob"
                placeholder="Contact mobile cannot be empty"
              />
            </FormItem>
            <FormItem label="Telephone：" :required="true">
              <Row>
                <Col span="3" style="padding: 0;">
                  <FormItem prop="LinkTel1">
                    <Input type="text" v-model="formInline.LinkTel1" />
                  </FormItem>
                </Col>
                <Col span="3" style="margin-left: 8px;">
                  <FormItem prop="LinkTel2">
                    <Input type="text" v-model="formInline.LinkTel2" />
                  </FormItem>
                </Col>
                <Col span="5" style="margin-left: 8px;">
                  <FormItem prop="LinkTel3">
                    <Input type="text" v-model="formInline.LinkTel3" />
                  </FormItem>
                </Col>
                <Col span="8">
                  <p style="color: #ccc;">&nbsp;&nbsp;e.g. +86-10-84666617</p>
                </Col>
              </Row>
            </FormItem>
            <FormItem label="传真：" :label-width="75" v-if="false">
              <Row :gutter="8" type="flex" justify="space-between">
                <Col span="6">
                  <FormItem>
                    <Input type="text" v-model="formInline.LinkFax1" />
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem>
                    <Input type="text" v-model="formInline.LinkFax2" />
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem>
                    <Input type="text" v-model="formInline.LinkFax3" />
                  </FormItem>
                </Col>
              </Row>
            </FormItem>
            <FormItem label="Company profile in Chinese：" class="intTextarea" prop="introduction" style="margin-bottom: 0;">
              <Input
                type="textarea"
                :rows="4"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="100"
                v-model="formInline.introduction"
                placeholder="Please enter Company profile in Chinese"
              />
              <p style="text-align:right;color: #bfbfbf;">{{formInline.introduction.length}}/100</p>
            </FormItem>
            <FormItem label="Company profile in English：" class="intTextarea" prop="enIntroduction" style="margin-bottom: 0;">
              <Input
                type="textarea"
                :rows="4"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="350"
                v-model="formInline.enIntroduction"
                placeholder="Please enter company profile in English"
              />
              <p style="text-align:right;color: #bfbfbf;">{{formInline.enIntroduction.length}}/350</p>
            </FormItem>
            <FormItem label="中文公司简介及产品简介：" v-if="false" class="intTextarea" prop="profile" style="margin-bottom: 0;">
              <Input
                type="textarea"
                :rows="4"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="500"
                v-model="formInline.profile"
                placeholder="请输入中文公司简介及产品简介"
              />
              <p style="text-align:right;color: #bfbfbf;">{{formInline.profile.length}}/500</p>
            </FormItem>
            <FormItem label="英文公司简介及产品简介：" v-if="false" class="intTextarea" prop="enProfile">
              <Input
                type="textarea"
                :rows="4"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="500"
                v-model="formInline.enProfile"
                placeholder="请输入英文公司简介及产品简介"
              />
              <p style="text-align:right;color: #bfbfbf;">{{formInline.enProfile.length}}/500</p>
            </FormItem>
            <FormItem style="padding-top: 20px;">
              <Button
                type="primary"
                size="large"
                @click="handleSubmit('formInline')"
                style="width: 154px;"
              >Save</Button>
            </FormItem>
          </Form>
        </div>
      </div>
    </div>

    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />

    <!-- 图片查看 -->
    <iModal title="View Picture" cancel-text v-model="visible">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import { validator } from "@/other/validatorEn";
import config from "@assets/config.json";

export default {
  name: "exhibition-info-catalogueAlterEdit",
  data() {
    const that = this;
    const logoReg = (rule, value, callback) => {
      if (that.uploadList && that.uploadList.length) {
        callback();
      } else {
        callback(new Error("请上传Logo"));
      }
    };
    const provinceReg = (rule, value, callback) => {
      if (
        that.provinceArr &&
        that.provinceArr.length &&
        !that.formInline.province
      ) {
        callback(new Error("请选择省份"));
      } else {
        callback();
      }
    };
    const tellReg = (rule, value, callback) => {
      if (!value) {
        callback(new Error("required"));
      } else {
        callback();
      }
    };
    const cityReg = (rule, value, callback) => {
      if (that.citiesArr && that.citiesArr.length && !that.formInline.city) {
        callback(new Error("请选择城市"));
      } else {
        callback();
      }
    };
    return {
      // staffArr: [
      //   {
      //     value: "10人以下",
      //     label: "10人以下"
      //   },
      //   {
      //     value: "10~50人",
      //     label: "10~50人"
      //   },
      //   {
      //     value: "50~100人",
      //     label: "50~100人"
      //   },
      //   {
      //     value: "100~500人",
      //     label: "100~500人"
      //   },
      //   {
      //     value: "500~1000人",
      //     label: "500~1000人"
      //   },
      //   {
      //     value: "1000~5000人",
      //     label: "1000~5000人"
      //   },
      //   {
      //     value: "5000人以上",
      //     label: "5000人以上"
      //   }
      // ],
      formInline: {
        name: "", // 公司名称
        exHall: "", // 展位号，修改时不用提交
        country: "",
        province: "",
        city: "",
        address: "", // 地址
        mail: "", // 邮政编码
        // type: "", // 企业类型
        // staff: "", // 人员规模
        // sales: "", // 年销售额
        url: "", // 公司网址
        email: "", // 公司邮箱
        LinkFirstName: "", // 联系人姓氏
        LinkLastName: "", // 联系人名字
        LinkMob: "", // 联系人手机号码
        LinkTel1: "",
        LinkTel2: "",
        LinkTel3: "",
        LinkFax1: "",
        LinkFax2: "",
        LinkFax3: "",
        introduction: "", // 会刊中文简介
        enIntroduction: "", // 会刊英文简介
        profile: "", // 中文公司简介及产品简介
        enProfile: "" // 英文公司简介及产品简介
      },
      ruleInline: {
        country: [
          { required: true, message: "Country/Region cannot be empty", trigger: "change" }
        ],
        province: [
          { required: true, validator: provinceReg, trigger: "change" }
        ],
        city: [{ required: true, validator: cityReg, trigger: "change" }],
        address: [
          { required: true, message: "Please enter the street number", trigger: "blur" }
        ],
        mail: [{ required: true, message: "Please enter the postal code", trigger: "blur" }],
        // type: [
        //   { required: true, message: "请选择企业类型", trigger: "change" }
        // ],
        // staff: [{ required: true, message: "请输入人员规模", trigger: "blur" }],
        // sales: [{ required: true, message: "请输入年销售额", trigger: "blur" }],
        email: validator.email,
        LinkFirstName: [{ required: true, message: "Surname", trigger: "blur" }],
        LinkLastName: [{ required: true, message: "first name", trigger: "blur" }],
        LinkMob: [
          { required: true, message: "Contact mobile cannot be empty", trigger: "blur" },
        ],
        introduction: [
          { required: true, message: "Please enter Company profile in Chinese", trigger: "blur" }
        ],
        enIntroduction: [
          { required: true, message: "Please enter company profile in English", trigger: "blur" }
        ],
        profile: [
          {
            required: true,
            message: "请输入中文公司简介及产品简介",
            trigger: "blur"
          }
        ],
        enProfile: [
          {
            required: true,
            message: "请输入英文公司简介及产品简介",
            trigger: "blur"
          }
        ],
        logo: [{ required: true, validator: logoReg, trigger: "blur" }],
        LinkTel1: [{ required: true, validator: tellReg, trigger: "blur" }],
        LinkTel2: [{ required: true, validator: tellReg, trigger: "blur" }],
        LinkTel3: [{ required: true, validator: tellReg, trigger: "blur" }],
      },
      countryList: [],
      provinceArr: [],
      citiesArr: [],
      // exTypeList: [],
      uploadList: [],
      defaultList: [],
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      imgName: "",
      visible: false,
      catalogueDownInfo: null // 会刊信息提交的修改内容
    };
  },
  components: {
    imgUpload
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      joinInfo: "loginModule/getJoinInfo",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    exhibitionId() {
      return this.exhibition.id;
    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - Show Catalogue";
    this.init();
  },
  methods: {
    ...mapActions({
      getCountryList: "exhibitionModule/getCountryList",
      getCityList: "exhibitionModule/getCityList",
      getCityByParentId: "exhibitionModule/getCityByParentId",
      getCatalogueType: "exhibitionModule/getCatalogueType",
      editCatalogueDown: "exhibitionModule/editCatalogueDown",
      getCatalogueDown: "exhibitionModule/getCatalogueDown",
    }),
    async init() {
      let countryList = await this.getCountryList();
      if (countryList && countryList.length > 0) {
        this.countryList = countryList;
      }
      this.formInline.name = this.company.name;
      // if (this.joinInfo && this.joinInfo.boothInfo) {
      //   let boothInfo = JSON.parse(this.joinInfo.boothInfo);
      //   for (let i = 0; i < boothInfo.length; i++) {
      //     if (boothInfo.length > 1) {
      //       this.formInline.exHall +=
      //         boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
      //     } else {
      //       this.formInline.exHall +=
      //         boothInfo[i].Hall + "-" + boothInfo[i].Code;
      //     }
      //   }
      // }
      if (this.joinInfo && this.joinInfo.boothInfo && this.joinInfo.boothInfo.length) {
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object String]') {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
        }
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Object]') {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
          if (this.joinInfo.boothInfo.Hall) {
            this.formInline.exHall = this.joinInfo.boothInfo.Hall + "-" + this.joinInfo.boothInfo.Code;
          } else {
            this.formInline.exHall = this.joinInfo.boothInfo.Code;
          }
        }
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Array]') {
          let boothInfo = this.joinInfo.boothInfo;
          for (let i = 0; i < boothInfo.length; i++) {
            if (boothInfo.length > 1) {
              if (boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
              }
              if (boothInfo[i].Hall && !boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "、";
              }
              if (!boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Code + "、";
              }
              
            } else {
              if (boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "-" + boothInfo[i].Code;
              }
              if (boothInfo[i].Hall && !boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall;
              }
              if (!boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Code;
              }

            }
          }
        }
        // this.formInline.exHall = boothInfo.Hall + '-' + boothInfo.Code;
      }
      // 获取会刊修改记录
      let result = await this.getCatalogueDown(this.joinInfo.joinId);
      if (result) {
        this.catalogueDownInfo = result;
        console.log(this.catalogueDownInfo);
      }
      // let res = await this.getCatalogueType();
      // if (res) {
      //   this.exTypeList = res;
      // }
      if (this.catalogueDownInfo) {
        this.formInline.country = this.catalogueDownInfo.area;
        this.formInline.province = this.catalogueDownInfo.province;
        this.formInline.city = this.catalogueDownInfo.city;
        if (this.formInline.country === "中国") {
          // let provinceList = await this.getCityList();
          let provinceList = await this.getCityByParentId("2710E818-5B91-4AA2-BCAD-0EF42A3DD6FD");
          if (provinceList && provinceList.length > 0) {
            provinceList.sort((a, b) => a.pinyin.charCodeAt(0) - b.pinyin.charCodeAt(0));
            // this.provinceArr = provinceList[0].list;
            this.provinceArr = provinceList;
            let provinceId = "";
            this.provinceArr.map(c => {
              if (c.shortname === this.formInline.province) {
                provinceId = c.id;
              }
            })
            if (provinceId) {
              let cityList = await this.getCityByParentId(provinceId);
              if (cityList && cityList.length > 0) {
                this.citiesArr = cityList;
              }
            }
          }
        }

        // for (var i = 0; i < this.provinceArr.length; i++) {
        //   if (this.catalogueDownInfo.province == this.provinceArr[i].shortname) {
        //     this.citiesArr = this.provinceArr[i].list;
        //   }
        // }
        this.formInline.address = this.catalogueDownInfo.address;
        this.formInline.mail = this.catalogueDownInfo.postcode;
        // this.formInline.type = this.catalogueDownInfo.industry;
        // this.formInline.staff = this.catalogueDownInfo.scale;
        // this.formInline.sales = this.catalogueDownInfo.annualSales;
        this.formInline.url = this.catalogueDownInfo.website;
        this.formInline.email = this.catalogueDownInfo.email;
        this.formInline.LinkFirstName = this.catalogueDownInfo.linkFirstName;
        this.formInline.LinkLastName = this.catalogueDownInfo.linkLastName;
        this.formInline.LinkMob = this.catalogueDownInfo.linkMob;

        let telArr = [];
        if (this.catalogueDownInfo.linkTel) {
          telArr = this.catalogueDownInfo.linkTel.split("-");
        }
        if (telArr[0]) {
          this.formInline.LinkTel1 = telArr[0];
        }
        if (telArr[1]) {
          this.formInline.LinkTel2 = telArr[1];
        }
        if (telArr[2]) {
          this.formInline.LinkTel3 = telArr[2];
        }
        // let faxArr = this.catalogueDownInfo.linkFax.split("-");
        // if (faxArr[0]) {
        //   this.formInline.LinkFax1 = faxArr[0];
        // }
        // if (faxArr[1]) {
        //   this.formInline.LinkFax2 = faxArr[1];
        // }
        // if (faxArr[2]) {
        //   this.formInline.LinkFax3 = faxArr[2];
        // }
        this.formInline.introduction = this.catalogueDownInfo.introduction;
        this.formInline.enIntroduction = this.catalogueDownInfo.introductionEn;
        this.formInline.profile = this.catalogueDownInfo.profile;
        this.formInline.enProfile = this.catalogueDownInfo.profileEn;
        if (this.catalogueDownInfo.logo) {
          let uploadList = [{
            percentage: 100,
            status: "finished",
            url: this.catalogueDownInfo.logo
          }];
          this.uploadList = uploadList;
        }
      }
    },
    async handleSubmit(name) {
      let txt = "";
      let valid = await this.validForm(name);
      this.$refs[name].fields.forEach(c => {
        if (txt) return;
        if (c.validateState === "error") {
          txt = c.validateMessage;
        }
      });
      if (!valid && txt) {
        this.$Message.warning(txt);
      } 
      if (!valid) {
        return;
      }

      let Logo = "";
      if (this.uploadList && this.uploadList.length) {
        Logo = this.uploadList[0].url;
      }

      let LinkTel = "";
      if (this.formInline.LinkTel2 && this.formInline.LinkTel3) {
        LinkTel =
          this.formInline.LinkTel1 +
          "-" +
          this.formInline.LinkTel2 +
          "-" +
          this.formInline.LinkTel3;
      }
      if (!this.formInline.LinkTel2) {
        LinkTel = this.formInline.LinkTel1 + "-" + this.formInline.LinkTel3;
      }
      if (!this.formInline.LinkTel3) {
        LinkTel = this.formInline.LinkTel1 + "-" + this.formInline.LinkTel2;
      }
      if (!this.formInline.LinkTel2 && !this.formInline.LinkTel3) {
        LinkTel = String(this.formInline.LinkTel1);
      }

      let LinkFax = "";
      if (this.formInline.LinkFax2 && this.formInline.LinkFax3) {
        LinkFax =
          this.formInline.LinkFax1 +
          "-" +
          this.formInline.LinkFax2 +
          "-" +
          this.formInline.LinkFax3;
      }
      if (!this.formInline.LinkFax2) {
        LinkFax = this.formInline.LinkFax1 + "-" + this.formInline.LinkFax3;
      }
      if (!this.formInline.LinkFax3) {
        LinkFax = this.formInline.LinkFax1 + "-" + this.formInline.LinkFax2;
      }
      if (!this.formInline.LinkFax2 && !this.formInline.LinkFax3) {
        LinkFax = String(this.formInline.LinkFax1);
      }

      let req = {
        CompName: this.formInline.name,
        Logo: Logo,
        Area: this.formInline.country,
        Province: this.formInline.province,
        City: this.formInline.city,
        Address: this.formInline.address,
        Postcode: this.formInline.mail,
        // Industry: this.formInline.type,
        // Scale: this.formInline.staff,
        // AnnualSales: this.formInline.sales,
        Website: this.formInline.url,
        Email: this.formInline.email,
        LinkFirstName: this.formInline.LinkFirstName,
        LinkLastName: this.formInline.LinkLastName,
        LinkMob: this.formInline.LinkMob,
        LinkTel: LinkTel,
        // LinkFax: LinkFax,
        Introduction: this.formInline.introduction,
        IntroductionEn: this.formInline.enIntroduction,
        // Profile: this.formInline.profile,
        // ProfileEn: this.formInline.enProfile
      }; 
      let opt = {
        Id: this.catalogueDownInfo.id,
        SetValues: req
      };
      let result = await this.editCatalogueDown(opt);
      if (result && result.successed) {
        this.$Message.success("successful");
        this.$router.push("/exhibitionEn/index/exinfo/catalogue-alter");
      } else {
        this.$Message.warning(`fail,please try again`);
      }
    },
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => { 
          resolve(valid);
        });
      });
    },
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return;
        } else {
          this.uploadList.push({
            percentage: 100,
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    },
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    selectType() {
      this.uploadList = [];
      this.defaultList = [];
      this.$refs.upload.fileList = [];
      this.uploadChooseShowed = true;
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "Incorrect file format",
        desc: "Upload image in jpg/png format"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "File size exceeds configured limit",
        desc: "Upload image size less than 2M"
      });
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload ${limitNum} image only`
        });
      }
      return check;
    },
    async changeCountry(val) {
      if (val === "中国") {
        // let provinceList = await this.getCityList();
        let provinceList = await this.getCityByParentId("2710E818-5B91-4AA2-BCAD-0EF42A3DD6FD");
        if (provinceList && provinceList.length > 0) {
          provinceList.sort((a, b) => a.pinyin.charCodeAt(0) - b.pinyin.charCodeAt(0));
          // this.provinceArr = provinceList[0].list;
          this.provinceArr = provinceList;
        }
      } else {
        this.provinceArr = [];
        this.citiesArr = [];
        this.formInline.province = "";
        this.formInline.city = "";
      }
    },
    changeProvince(val) {
      // for (var i = 0; i < this.provinceArr.length; i++) {
      //   if (val == this.provinceArr[i].shortname) {
      //     this.citiesArr = this.provinceArr[i].list;
      //   }
      // }
    },
    async changeProvinceValue(item) {
      let cityList = await this.getCityByParentId(item.id);
      if (cityList && cityList.length > 0) {
        this.citiesArr = cityList;
      } else {
        this.formInline.city = "";
        this.citiesArr = [];
      }
    },
    changeCountryValue(val) {
      this.formInline.LinkTel1 = val.code;
      // this.formInline.LinkFax1 = val.code;
    },
    changeCity(val) {
      this.formInline.LinkTel2 = val.citycode;
      // this.formInline.LinkFax2 = val.citycode;
    }
  }
};
</script>

<style lang="scss">
.intTextarea {
  .ivu-form-item-error-tip {
    top: 75%;
  }
}
</style>
<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1400px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
    &-l {
      width: 50%;
      min-width: 700px;
    }
    &-r {
      display: flex;
      min-width: 700px;
      .logo-example {
        display: flex;
        &-box {
          display: flex;
          flex-wrap: wrap;
          flex: 1;
        }
        &-item {
          display: flex;
          width: 100%;
          p {
            font-size: 12px;
            color: #808080;
            padding-left: 10px;
          }
          &.z-large-s {
            img {
              width: 40px;
              height: 40px;
              border: 1px solid #bfbfbf;
            }
            p {
              line-height: 40px;
            }
          }
          &.z-large-m {
            img {
              width: 30px;
              height: 30px;
              border: 1px solid #bfbfbf;
            }
            p {
              line-height: 30px;
            }
          }
          &.z-large-l {
            img {
              width: 20px;
              height: 20px;
              border: 1px solid #bfbfbf;
            }
            p {
              line-height: 20px;
            }
          }
        }
      }
    }
  }
  .mask {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
